var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-459.000000, -196.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "477.538462 197 465.846154 197 460 215.909091 467.307692 215.909091 462.923077 229 479 210.090909 470.230769 210.090909"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequired);
export default __webpack_public_path__ + "static/media/icon-required.bfa1b3f607583fc940c1d1f128740bf4.svg";
export { ForwardRef as ReactComponent };